console.log('Hello from assets folder, packed with @wordpress/scripts !');